export const host = "https://blitz-chat-ptqd.onrender.com";
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;
export const allUsersRoute = `${host}/api/auth/allusers`
export const sendMessageRoute = `${host}/api/messages/addmsg`
export const getAllMessagesRoute = `${host}/api/messages/getmsg`